<template>
  <div class="popup" :style="getSyle">
    <div style="width: 100%; display: flex; justify-content: space-between">
      <h3>{{ projectName }} - {{ projectCountry }}</h3>
      <span style="cursor: pointer" @click="this.$emit('closePopup')">X</span>
    </div>
    <div v-if="data?.config && data?.data" class="analytics-wrapper">
      <Chart
        type="chart"
        :options="data.config"
        :data="data.data"
        id="analytics-chart-completed"
        style="width: 100%"
      ></Chart>
    </div>
    <div v-else>
      <h1>No Data for this Project</h1>
    </div>
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  Filler,
} from 'chart.js'
import { Chart, Bar, Scatter, Line } from 'vue-chartjs'
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
)
export default {
  name: 'mapPopup',
  props: {
    data: Object,
    projectType: String,
    projectName: String,
    projectCountry: String,
    changePopUpStyle: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {}
  },
  components: {
    Chart,
    Bar,
    Scatter,
    Line,
  },
  computed: {
    getSyle() {
      if (this.changePopUpStyle) {
        return {
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.popup {
  align-self: center;
  width: 90%;
  background: white;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 2rem;
  max-height: 70%;
  overflow-y: auto;
  box-shadow: 0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%);
  transition: box-shadow 0.08s linear,
    min-width 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 100;
  height: 350px;

  .popup-btns {
    margin-top: 8px;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #091e4214;
  }
  &::-webkit-scrollbar-thumb {
    background: #091e4214;
  }
  &::-webkit-scrollbar-track {
    background: #091e4214;
    border-radius: 10px;
  }
}

.analytics-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
}
</style>
